import OptionItem from './OptionItem';

const ButtonClose = () => {
  return '<button type="button" data-role="close" class="close">닫기</button>';
};

const ButtonOpen = () => {
  return '<button type="button" data-role="list-trigger" class="tit_opt" data-tlarea="DDO0" data-tlord="4"></button>';
};

const ButtonSelect = isSingle => {
  if (!isSingle) return '';
  return `<button type="button" class="btn_select_option">옵션선택</button>`;
};

const Container = (optionNodes) => {
  if (!optionNodes) return '';
  return `<div class="opt_sel" data-role="list-controller">
    ${ButtonOpen()}
    <ul>${optionNodes.map(OptionItem).join("")}</ul>
  </div>`;
};

const OptionSelect = (isSingle, optionNodes) => {
  if (TMON.oApp.sPlatform !== 'PW') return '';

  return `<div class="hd" style="display:block">
    <h4 class="tit">자세히보기</h4>
    ${ButtonClose()}
    <div class="product_select_wrap ${isSingle ? 'single' : ''}">
    ${Container(optionNodes)}
    ${ButtonSelect(isSingle)}
    </div>
  </div>`;
};

export default OptionSelect;
